var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#email_svg__clip0_5627_107161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.386 7.397L6.71 10.438a2.444 2.444 0 00-2.037 2.833l2.538 14.715a2.55 2.55 0 002.882 2.073l19.677-3.041a2.444 2.444 0 002.037-2.833L29.269 9.469a2.55 2.55 0 00-2.883-2.072zm2.961 17.168l-2.46.38-1.86-10.791-6.576 5.8-8.182-3.52 1.861 10.792-2.46.38-2.537-14.715 1.475-.229 9.251 3.858 7.475-6.442 1.475-.229 2.538 14.716z",
    fill: "#85A5FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "email_svg__clip0_5627_107161"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "matrix(.98827 -.15274 .16995 .98545 0 5)",
    d: "M0 0h32v32H0z"
  })))));
}

export default __webpack_public_path__ + "./fonts/email.3681f3dcba13c610a7897ae794a8fe8f.svg";
export { SvgEmail as ReactComponent };